// extracted by mini-css-extract-plugin
export var container = "styles-module--container--aEXui";
export var innercontainer = "styles-module--innercontainer--QQHyk";
export var info = "styles-module--info--93w1X";
export var demo = "styles-module--demo--1hQwk";